import {
  Component,
  EventEmitter,
  Input,
  Output} from '@angular/core';
import {NavBaseComponent} from '../../nav-base/nav-base.component';
import {FormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {AppUtils} from '../../../shared/app-utils';
import {HtmlUtilsService} from "../../../html-utils/html-utils.service";
import {AutoCompleteAction} from '../nav-search.component';
import {debounceTime, distinctUntilChanged} from 'rxjs/internal/operators';
import {TranslateService} from '../../../shared/translate.service';
import {AppConfigService} from "../../../config/app-config.service";
import {environment} from "../../../../environments/environment";


@Component({
  selector: 'app-nav-search-box',
  templateUrl: './nav-search-box.component.html',
  styleUrls: ['./nav-search-box.component.scss']
})
export class NavSearchBoxComponent extends NavBaseComponent {

  private fulltextBaseUrl = environment.fulltextUrl

  @Input() showLogo = true;

  @Output() searchActionNotifier = new EventEmitter<boolean>();

  autoCompleteActionEmitter = new EventEmitter<AutoCompleteAction>();

  phraseField = new FormControl();

  focused = false;

  hasSuggest = false;

  suggestNumber = 0;

  hasFocusSuggest = false;

  manualAutoCompleteClose = false;

  searchInText: boolean;

  logoTextKey: string;

  showLogoText: boolean = false;

  highContrast: boolean = false;

  constructor(private router: Router,
              private htmlUtils: HtmlUtilsService,
              private translator: TranslateService,
              private appConfigService: AppConfigService) {
    super();
    this.highContrast = this.htmlUtils.contrast;
    this.htmlUtils.highContrast.subscribe((value) => {
      if (value !== this.highContrast) {
        this.highContrast = value;
      }
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.logoTextKey = this.appConfigService.mainPageConfig.messageKey;
    this.showLogoText = this.appConfigService.mainPageConfig.active;
    this.searchInText = this.htmlUtils.searchInText;
    this.phraseField.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged()).subscribe(value => {
      this.manualAutoCompleteClose = false;
    });
  }

  onSubmit() {
    this.search(this.phraseField.value, this.searchInText);
  }

  search(phrase: string, searchInText: boolean = false): void {
    if (this.searchInText){
      this.htmlUtils.toogleSearchInTextCheckbox(searchInText);
      this.redirectToFulltext(phrase);
    } else {
      let filters = AppUtils.phraseToFilter(phrase).toURL();
      filters = filters.concat(',_type:-work');
      this.router.navigate(['/search/s/'], {
        queryParams: {page: 1, searchInText: searchInText, query: phrase, filters}
      }).then(()=>this.searchActionNotifier.emit(true));
    }
  }

  markFocused() {
    this.focused = true;
  }

  markBlured() {
    this.focused = false;
  }

  redirectToBrowse() {
    this.router.navigate(['/search/b/'] , { queryParams: {filters: '_type:-work'}}).then(()=>this.searchActionNotifier.emit(true));
  }

  toggleSearchInText(event) {
    if (event && event.which && (event.which == 1 || event.which == 32)) {
      this.searchInText = !this.searchInText;
      event.preventDefault();
    }
  }

  canShowAutoComplete(){
    return this.focused && this.hasSuggest && !this.searchInText && !this.manualAutoCompleteClose;
  }

  triggerArrowDown() {
    if (this.manualAutoCompleteClose){
      this.manualAutoCompleteClose = false;
    }else{
      this.autoCompleteActionEmitter.emit(AutoCompleteAction.ARROW_DOWN);
    }
  }

  triggerArrowUp() {
    if (this.canShowAutoComplete()){
      this.autoCompleteActionEmitter.emit(AutoCompleteAction.ARROW_UP);
    }
  }

  triggerEnter(event) {
    if (this.canShowAutoComplete() && this.hasFocusSuggest){
      event.preventDefault();
      this.autoCompleteActionEmitter.emit(AutoCompleteAction.ENTER);
    }
  }

  getAriaLabel() {
    if (this.canShowAutoComplete()){
      return this.translator.translate('home.suggeston.count')+' '+this.suggestNumber;
    }else{
      return this.translator.translate( 'home.suggeston.aria.label');
    }
  }

  redirectToFulltext(phrase: string) {
    window.location.href = `${this.fulltextBaseUrl}/results?query=${phrase}`;
  }
}
